
/** @deprecated use GenericBackResponse instead */
export interface DataWrapper<T> {
    data: T[];
}